
import { Component, Vue, Watch } from 'vue-property-decorator';
import { modules } from '@/router';

@Component({
  components: {},
})
export default class HomeView extends Vue {
  modules: any = modules;
  roleType: any = localStorage.getItem('roleTypeKeys');
  fullName: any = localStorage.getItem('fullName');
  cMenuName: any = this.$route.matched[1].name || 'user';

  @Watch('$route')
  changePath(val: any) {
    this.cMenuName = val.name;
  }

  get isSuperAdmin() {
    return localStorage.getItem('superAdmin') === 'true';
  }

  hasTop: any = false;

  created() {
    this.getLangList();
    this.getVersionList();
    if (this.isSuperAdmin) {
      this.currentStep = 2;
      this.hasTop = false;
    } else {
      this.currentStep = 1;
      this.hasTop = true;
    }
  }

  formatName(name: any) {
    return name.charAt(name.length - 1);
  }

  toPage(routerName: any) {
    this.cMenuName = routerName;
    this.$router.push({ name: routerName }).catch((err) => err);
  }

  exit() {
    localStorage.removeItem('Authorization');
    localStorage.removeItem('loginName');
    localStorage.removeItem('roleTypeKeys');
    localStorage.removeItem('superAdmin');
    location.reload();
  }

  // 判断当前路由是否是某个父菜单的子菜单
  isChildActive(children: any[]) {
    return children.some((child) => child.name === this.cMenuName);
  }

  versionId: any = '';
  versionList: any = [];
  versionStatus: any = 'inProgress';
  canEdit: any = false;

  canEditForVersion(version: any) {
    return version?.status === 'inProgress' && version?.permission !== 'View';
  }

  async getVersionList() {
    let res: any = [];

    if (this.isSuperAdmin) {
      res = await this.$store.dispatch({
        type: 'resource/getVersionList',
      });
    } else {
      res = await this.$store.dispatch({
        type: 'resource/getVersionListSelf',
      });
    }

    this.versionList = res.data.data;
    const foundItem = this.versionList[0];
    this.versionId = foundItem?.id;
    this.versionStatus = foundItem?.status || 'inProgress';
    this.canEdit = this.canEditForVersion(foundItem);
    // this.canEdit = true;
  }

  changeVersion(id: any) {
    this.versionId = id;
    const foundItem = this.versionList.find((obj: any) => obj.id === id);
    this.versionStatus = foundItem.status;
    this.canEdit = this.canEditForVersion(foundItem);
    // this.canEdit = true;
  }

  currentStep: any = 1;

  changeStep(step: any) {
    this.currentStep = step;

    if (step === 3) {
      this.getVersionDetail();
    }
  }

  curVerName: any = '';
  description: any = '';

  async getVersionDetail() {
    const res = await this.$store.dispatch({
      type: 'version/getDetail',
      data: {
        id: this.versionId,
      },
    });

    this.description = res.data.data.description;
    this.curVerName = res.data.data.versionName;
  }

  async submitVersion() {
    this.$Modal.confirm({
      title: '提交',
      content:
        '<p>确定提交版本“' +
        this.curVerName +
        '”吗？</p>' +
        '<p>提交后将不能再对此版本数据进行编辑维护！</p>',
      onOk: async () => {
        try {
          await this.$store.dispatch({
            type: 'resource/submitVersion',
            data: {
              id: this.versionId,
              description: this.description,
            },
          });

          this.getVersionList();
          // this.changeStep(1);
          this.canEdit = false;
        } catch (e) {
          this.$Modal.remove();
        }
      },
    });
  }

  langList: any = [];

  async getLangList() {
    const res = await this.$store.dispatch({
      type: 'lang/getLangList',
      data: {
        firstLang: false,
      },
    });

    this.langList = res.data.data;
  }

  changeLang(langKey: any) {
    localStorage.setItem('secondLang', langKey);
    location.reload();
  }

  get secondLang() {
    return localStorage.getItem('secondLang') || 'en';
  }
}
